export const EN = 'en';
export const FR = 'fr';
export const ES = 'es';
